import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeasuresModule } from 'ngx-zcs-components';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IonicModule } from '@ionic/angular';

import { ImgLoadComponent } from './img-load/img-load.component';
import { EnergyStatisticsCardComponent } from './energy-statistics-card/energy-statistics-card.component';

@NgModule({
  declarations: [
    EnergyStatisticsCardComponent,
    ImgLoadComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    MatIconModule,
    MeasuresModule,
  ],
  exports: [
    EnergyStatisticsCardComponent,
  ],
})
export class ComponentsModule {
  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
  ) {
    this.matIconRegistry.addSvgIcon(
      'block_home',
      this.domSanitizer.bypassSecurityTrustResourceUrl('blocks-assets/images/home.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'block_battery',
      this.domSanitizer.bypassSecurityTrustResourceUrl('blocks-assets/images/battery.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'block_solar',
      this.domSanitizer.bypassSecurityTrustResourceUrl('blocks-assets/images/solar.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'block_grid',
      this.domSanitizer.bypassSecurityTrustResourceUrl('blocks-assets/images/grid.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'block_irradiance',
      this.domSanitizer.bypassSecurityTrustResourceUrl('blocks-assets/images/irradiance.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'no_data',
      this.domSanitizer.bypassSecurityTrustResourceUrl('blocks-assets/images/generics/no-data.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'block_verified',
      this.domSanitizer.bypassSecurityTrustResourceUrl('blocks-assets/images/generics/verified.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'block_expired',
      this.domSanitizer.bypassSecurityTrustResourceUrl('blocks-assets/images/generics/expired.svg'),
    );
  }
}
